export default function classNames(...x) {
  return x.filter(Boolean).join(" ");
}